import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"

const InfoContainer = styled(Flex)`
  border-bottom: ${({ isLastItem }) => (isLastItem ? "none" : "solid 1px #C8D2D1")};
  @media (min-width: ${theme.mediaqueries.small}) {
    align-items: center;
  }
  svg {
    width: 50px;
    height: 50px;
    @media (min-width: ${theme.mediaqueries.small}) {
      width: 75px;
      height: 75px;
    } 
    @media (min-width: ${theme.mediaqueries.medium}) {
      width: 100px;
      height: 100px;
    } 
  }
`

const ModalInfo = (props) => {
  const { data } = props

  return (
    <Box pb={[80, 40, 0, 0]}>
      <Box className="text-center" paddingTop={["10px", null, "40px"]}>
        <TextElementMen element="h2" text={data.modalHeading} className="title--medium gothic text-master-secondary-default" />
      </Box>
      {
        data.items.map((item, index) => {
          const Icon = item.image
          const isLastItem = index === data.items.length - 1
          const paddingBottom = isLastItem ? "0" : "24px"

          return (
            <InfoContainer key={`item-${index}`} paddingTop={"24px"} paddingBottom={paddingBottom} isLastItem={isLastItem}>
              <Box marginRight={["16px", "16px", "24px"]}>
                <Icon />
              </Box>
              <Box>
                <TextElementMen element="h3" text={item.heading} className="body--xlarge-b text-master-secondary-default mb-2" />
                <TextElementMen element="p" text={item.modalText} className="body--large text-master-secondary-default" />
              </Box>
            </InfoContainer>
          )
        })
      }
    </Box>
  )
}

export default ModalInfo
